import { render } from "./application.vue?vue&type=template&id=710a45ef"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"

import "./application.vue?vue&type=style&index=0&id=710a45ef&lang=scss"

import exportComponent from "D:\\工作空间\\xx-fds-protal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__